module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-menu"
  }, [_c('div', {
    staticClass: "top-menu-center"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "fzg-menu"
  }, [_c('div', {
    staticClass: "menu-item",
    class: {
      'menu-item-active': _vm.isMenuActive('/')
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'menu-item-active': _vm.isMenuActive('/about')
    }
  }, [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_vm._v("关于我们")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'menu-item-active': _vm.isMenuActive('/service')
    }
  }, [_c('a', {
    attrs: {
      "href": "/service"
    }
  }, [_vm._v("小饭桌创服")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'menu-item-active': _vm.isMenuActive('/investment')
    }
  }, [_c('a', {
    attrs: {
      "href": "/investment"
    }
  }, [_vm._v("小饭桌创投")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'menu-item-active': _vm.isMenuActive('/fa')
    }
  }, [_c('a', {
    attrs: {
      "href": "/fa"
    }
  }, [_vm._v("凡卓资本")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'menu-item-active': _vm.isMenuActive('/news')
    }
  }, [_c('a', {
    attrs: {
      "href": "/news"
    }
  }, [_vm._v("动态新闻")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'menu-item-active': _vm.isMenuActive('/join')
    }
  }, [_c('a', {
    attrs: {
      "href": "/join"
    }
  }, [_vm._v(" 加入我们")])]), _vm._v(" "), _c('a', {
    staticClass: "menu-item menu-media",
    attrs: {
      "href": "https://www.xfz.cn/",
      "target": "blank"
    }
  }, [_vm._v("小饭桌媒体门户")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "main-logo",
    attrs: {
      "src": require("../../assets/img2/pc/fzg-logo.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-644b0db4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FzgMenu.vue
// module id = 231
// module chunks = 0